import { languageType } from '../util/languageType';
import { getLocaleMessages } from '../util/localeMessages';
import { getLanguageCode } from '../util/locales';
import cookie from '../assets/cookie.svg';
import { loadMoosendTracking, trackMoosendPageView } from '../util/moosendTracking';

const imgTag = `<img src="${cookie}" alt="cookie" style="width: 20px; height: 20px;"/>`;

const messages = getLocaleMessages(languageType());

export const createCookieTranslations = messages => ({
  consentModal: {
    title: messages['CookieConfig.ConsentModal.Title'] + imgTag,
    description: messages['CookieConfig.ConsentModal.Description'],
    acceptAllBtn: messages['CookieConfig.ConsentModal.AcceptAllBtn'],
    showPreferencesBtn: messages['CookieConfig.ConsentModal.ShowPreferencesBtn'],
    // Note: closeIconLabel is intentionally omitted so users must actively choose
    acceptNecessaryBtn: messages['CookieConfig.ConsentModal.AcceptNecessaryBtn'],
  },
  preferencesModal: {
    title: messages['CookieConfig.PreferencesModal.Title'],
    acceptAllBtn: messages['CookieConfig.PreferencesModal.AcceptAllBtn'],
    savePreferencesBtn: messages['CookieConfig.PreferencesModal.SavePreferencesBtn'],
    closeIconLabel: messages['CookieConfig.PreferencesModal.CloseIconLabel'],
    sections: [
      {
        title: messages['CookieConfig.PreferencesModal.Sections.CookieUsage.Title'],
        description: messages['CookieConfig.PreferencesModal.Sections.CookieUsage.Description'],
      },
      {
        title: messages['CookieConfig.PreferencesModal.Sections.StrictlyNecessary.Title'],
        description:
          messages['CookieConfig.PreferencesModal.Sections.StrictlyNecessary.Description'],
        linkedCategory: 'necessary',
        cookieTable: {
          headers: {
            name:
              messages[
                'CookieConfig.PreferencesModal.Sections.StrictlyNecessary.CookieTable.Headers.Name'
              ],
            domain:
              messages[
                'CookieConfig.PreferencesModal.Sections.StrictlyNecessary.CookieTable.Headers.Domain'
              ],
            description:
              messages[
                'CookieConfig.PreferencesModal.Sections.StrictlyNecessary.CookieTable.Headers.Description'
              ],
            expiration:
              messages[
                'CookieConfig.PreferencesModal.Sections.StrictlyNecessary.CookieTable.Headers.Expiration'
              ],
          },
          body: [
            {
              name:
                messages[
                  'CookieConfig.PreferencesModal.Sections.StrictlyNecessary.CookieTable.Body.stHostedToken.Name'
                ],
              domain:
                messages[
                  'CookieConfig.PreferencesModal.Sections.StrictlyNecessary.CookieTable.Body.stHostedToken.Domain'
                ],
              description:
                messages[
                  'CookieConfig.PreferencesModal.Sections.StrictlyNecessary.CookieTable.Body.stHostedToken.Description'
                ],
              expiration:
                messages[
                  'CookieConfig.PreferencesModal.Sections.StrictlyNecessary.CookieTable.Body.stHostedToken.Expiration'
                ],
            },
            {
              name:
                messages[
                  'CookieConfig.PreferencesModal.Sections.StrictlyNecessary.CookieTable.Body.Language.Name'
                ],
              domain:
                messages[
                  'CookieConfig.PreferencesModal.Sections.StrictlyNecessary.CookieTable.Body.Language.Domain'
                ],
              description:
                messages[
                  'CookieConfig.PreferencesModal.Sections.StrictlyNecessary.CookieTable.Body.Language.Description'
                ],
              expiration:
                messages[
                  'CookieConfig.PreferencesModal.Sections.StrictlyNecessary.CookieTable.Body.Language.Expiration'
                ],
            },
            {
              name:
                messages[
                  'CookieConfig.PreferencesModal.Sections.StrictlyNecessary.CookieTable.Body.StripeMid.Name'
                ],
              domain:
                messages[
                  'CookieConfig.PreferencesModal.Sections.StrictlyNecessary.CookieTable.Body.StripeMid.Domain'
                ],
              description:
                messages[
                  'CookieConfig.PreferencesModal.Sections.StrictlyNecessary.CookieTable.Body.StripeMid.Description'
                ],
              expiration:
                messages[
                  'CookieConfig.PreferencesModal.Sections.StrictlyNecessary.CookieTable.Body.StripeMid.Expiration'
                ],
            },
            {
              name:
                messages[
                  'CookieConfig.PreferencesModal.Sections.StrictlyNecessary.CookieTable.Body.StripeSid.Name'
                ],
              domain:
                messages[
                  'CookieConfig.PreferencesModal.Sections.StrictlyNecessary.CookieTable.Body.StripeSid.Domain'
                ],
              description:
                messages[
                  'CookieConfig.PreferencesModal.Sections.StrictlyNecessary.CookieTable.Body.StripeSid.Description'
                ],
              expiration:
                messages[
                  'CookieConfig.PreferencesModal.Sections.StrictlyNecessary.CookieTable.Body.StripeSid.Expiration'
                ],
            },
          ],
        },
      },
      {
        title: messages['CookieConfig.PreferencesModal.Sections.Advertising.Title'],
        description: messages['CookieConfig.PreferencesModal.Sections.Advertising.Description'],
        linkedCategory: 'advertising',
        cookieTable: {
          headers: {
            name:
              messages[
                'CookieConfig.PreferencesModal.Sections.Advertising.CookieTable.Headers.Name'
              ],
            domain:
              messages[
                'CookieConfig.PreferencesModal.Sections.Advertising.CookieTable.Headers.Domain'
              ],
            description:
              messages[
                'CookieConfig.PreferencesModal.Sections.Advertising.CookieTable.Headers.Description'
              ],
            expiration:
              messages[
                'CookieConfig.PreferencesModal.Sections.Advertising.CookieTable.Headers.Expiration'
              ],
          },
          body: [
            {
              name:
                messages[
                  'CookieConfig.PreferencesModal.Sections.Advertising.CookieTable.Body.Fbp.Name'
                ],
              domain:
                messages[
                  'CookieConfig.PreferencesModal.Sections.Advertising.CookieTable.Body.Fbp.Domain'
                ],
              description:
                messages[
                  'CookieConfig.PreferencesModal.Sections.Advertising.CookieTable.Body.Fbp.Description'
                ],
              expiration:
                messages[
                  'CookieConfig.PreferencesModal.Sections.Advertising.CookieTable.Body.Fbp.Expiration'
                ],
            },
            {
              name:
                messages[
                  'CookieConfig.PreferencesModal.Sections.Advertising.CookieTable.Body.GclAu.Name'
                ],
              domain:
                messages[
                  'CookieConfig.PreferencesModal.Sections.Advertising.CookieTable.Body.GclAu.Domain'
                ],
              description:
                messages[
                  'CookieConfig.PreferencesModal.Sections.Advertising.CookieTable.Body.GclAu.Description'
                ],
              expiration:
                messages[
                  'CookieConfig.PreferencesModal.Sections.Advertising.CookieTable.Body.GclAu.Expiration'
                ],
            },
          ],
        },
      },
      {
        title: messages['CookieConfig.PreferencesModal.Sections.PerformanceAnalytics.Title'],
        description:
          messages['CookieConfig.PreferencesModal.Sections.PerformanceAnalytics.Description'],
        linkedCategory: 'analytics',
        cookieTable: {
          headers: {
            name:
              messages[
                'CookieConfig.PreferencesModal.Sections.PerformanceAnalytics.CookieTable.Headers.Name'
              ],
            domain:
              messages[
                'CookieConfig.PreferencesModal.Sections.PerformanceAnalytics.CookieTable.Headers.Domain'
              ],
            description:
              messages[
                'CookieConfig.PreferencesModal.Sections.PerformanceAnalytics.CookieTable.Headers.Description'
              ],
            expiration:
              messages[
                'CookieConfig.PreferencesModal.Sections.PerformanceAnalytics.CookieTable.Headers.Expiration'
              ],
          },
          body: [
            {
              name:
                messages[
                  'CookieConfig.PreferencesModal.Sections.PerformanceAnalytics.CookieTable.Body.Ga.Name'
                ],
              domain:
                messages[
                  'CookieConfig.PreferencesModal.Sections.PerformanceAnalytics.CookieTable.Body.Ga.Domain'
                ],
              description:
                messages[
                  'CookieConfig.PreferencesModal.Sections.PerformanceAnalytics.CookieTable.Body.Ga.Description'
                ],
              expiration:
                messages[
                  'CookieConfig.PreferencesModal.Sections.PerformanceAnalytics.CookieTable.Body.Ga.Expiration'
                ],
            },
          ],
        },
      },
      {
        title: messages['CookieConfig.PreferencesModal.Sections.MoreInformation.Title'],
        description: messages['CookieConfig.PreferencesModal.Sections.MoreInformation.Description'],
      },
    ],
  },
});

// Helper to update Google Consent Mode
const updateGoogleConsent = (hasAnalytics, hasAdvertising) => {
  if (!window.gtag) return;
  window.gtag('consent', 'update', {
    analytics_storage: hasAnalytics ? 'granted' : 'denied',
    ad_storage: hasAdvertising ? 'granted' : 'denied',
    ad_user_data: hasAdvertising ? 'granted' : 'denied',
    ad_personalization: hasAdvertising ? 'granted' : 'denied',
  });
};

// Helper to send a GA4 page_view via the GTM dataLayer.
// send_to has been removed so GTM can route the event centrally.
const sendPageView = () => {
  if (!window.dataLayer) return;
  window.dataLayer.push({
    event: 'page_view',
    page_path: window.location.pathname,
  });
};

export const cookieConfig = {
  // Fired the first time user gives consent (e.g. clicks "Accept All")
  onFirstConsent: ({ cookie }) => {
    const hasAnalytics = cookie.categories.includes('analytics');
    const hasAdvertising = cookie.categories.includes('advertising');

    updateGoogleConsent(hasAnalytics, hasAdvertising);

    if (hasAdvertising) {
      loadMoosendTracking();
      trackMoosendPageView();
    }

    if (hasAnalytics) {
      sendPageView();
    }
  },

  // Fired when user changes preferences in the modal
  onChange: ({ cookie, changedCategories }) => {
    const hasAnalytics = cookie.categories.includes('analytics');
    const hasAdvertising = cookie.categories.includes('advertising');
    const analyticsChanged = changedCategories.includes('analytics');
    const advertisingChanged = changedCategories.includes('advertising');

    if (!analyticsChanged && !advertisingChanged) return;

    updateGoogleConsent(hasAnalytics, hasAdvertising);

    if (advertisingChanged && hasAdvertising) {
      loadMoosendTracking();
      trackMoosendPageView();
    }

    if (analyticsChanged && hasAnalytics) {
      sendPageView();
    }
  },
  guiOptions: {
    consentModal: {
      layout: 'box',
      position: 'bottom',
      equalWeightButtons: true,
      flipButtons: true,
      closeIconLabel: messages['CookieConfig.ConsentModal.CloseIconLabel'],
    },
    preferencesModal: {
      layout: 'box',
      position: 'right',
      equalWeightButtons: true,
      flipButtons: false,
      closeIconLabel: messages['CookieConfig.PreferencesModal.CloseIconLabel'],
    },
  },
  mode: 'opt-in',
  categories: {
    necessary: {
      enabled: true, // this category is enabled by default
      readOnly: true, // this category cannot be disabled
    },
    analytics: {
      enabled: false,
      onAccept: () => {
        console.log('Analytics cookies accepted');
      },
      onReject: () => {
        // Consent Mode handles analytics denial via gtag('consent', 'update', {analytics_storage: 'denied'})
      },
    },
    advertising: {
      enabled: false,
      onAccept: () => {
        // Moosend tracking is loaded by the consent callbacks in this file (onFirstConsent/onChange)
        console.log('Advertising cookies accepted');
      },
      onReject: () => {},
    },
  },
  language: {
    default: getLanguageCode(languageType()),
    translations: {
      en: createCookieTranslations(getLocaleMessages('en-US')),
      el: createCookieTranslations(getLocaleMessages('el')),
      es: createCookieTranslations(getLocaleMessages('es')),
    },
  },
};

export const getCookieConfig = locale => {
  const messages = getLocaleMessages(locale);
  return {
    ...cookieConfig,
    language: { ...cookieConfig.language, default: getLanguageCode(locale) },
    guiOptions: {
      ...cookieConfig.guiOptions,
      consentModal: {
        ...cookieConfig.guiOptions.consentModal,
        closeIconLabel: messages['CookieConfig.ConsentModal.CloseIconLabel'],
      },
      preferencesModal: {
        ...cookieConfig.guiOptions.preferencesModal,
        closeIconLabel: messages['CookieConfig.PreferencesModal.CloseIconLabel'],
      },
    },
  };
};
